import Deferred from "utils/Deferred";

/**
 * Promise always fires when Marketing Containers are ready for display.
 * @returns {Promise<Object>} of ready event data
 */
const marketingContainersReady = new Deferred();
export default marketingContainersReady;
